// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLES_TITLE = "\u010cl\u00e1nky";
export const STROLLEROPEDIA_NEW_ARTICLES_LONG = "Najnov\u0161ie \u010dl\u00e1nky v ko\u010d\u00edkop\u00e9dii";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
